export enum NodeShape {
  TRIANGLE = 'triangle', // Bioactive Entity
  DIAMOND = 'diamond', // RNA
  ROUNDED_RECTANGLE = 'round-rectangle', // Gene
  TAG = 'tag',
  VEE = 'vee', // DNA
  ELLIPSE = 'ellipse', // Protein,
  PARALLELOGRAM = 'rhomboid',
  OCTAGON = 'octagon',
  HEXAGON = 'hexagon',
}
